export const LIST_EXCEPTIONAL_UNAVAILABLE_TIMES = 'LIST_EXCEPTIONAL_UNAVAILABLE_TIMES'
export const LIST_EXCEPTIONAL_UNAVAILABLE_TIMES_FAILED = 'LIST_EXCEPTIONAL_UNAVAILABLE_TIMES_FAILED'
export const LIST_EXCEPTIONAL_UNAVAILABLE_TIMES_SUCCESS = 'LIST_EXCEPTIONAL_UNAVAILABLE_TIMES_SUCCESS'

export const CLEAR_EXCEPTIONAL_UNAVAILABLE_TIMES_LIST = 'CLEAR_EXCEPTIONAL_UNAVAILABLE_TIMES_LIST'
